import { useNavigate, useSearch } from "@tanstack/react-router";
import { Link01 } from "@untitledui/icons";
import { useEffect, useState } from "react";
import { useTikTokShopConnectionStatus } from "@/api/tiktok-shop";
import { PageLayout } from "@/components/page-layout";
import { PermissionsList, PromoVisual, ReconnectCallout } from "@/components/tiktok-seller-connections-modal";
import { success } from "@/providers/ToastProvider";

const SUCCESS_HIGHLIGHT_MS = 3200;

export function IntegrationsPage() {
  const { data: shopStatus } = useTikTokShopConnectionStatus();
  const navigate = useNavigate();
  const search = useSearch({ strict: false }) as { ads?: string };
  const [highlightAds, setHighlightAds] = useState(false);

  useEffect(() => {
    if (search.ads !== "connected") return;
    setHighlightAds(true);
    success("Authorized successfully", { description: "Advertising Data is connected." });
    navigate({ to: ".", search: {}, replace: true });
    const timeout = setTimeout(() => setHighlightAds(false), SUCCESS_HIGHLIGHT_MS);
    return () => clearTimeout(timeout);
  }, [search.ads, navigate]);

  return (
    <PageLayout title="Integrations" icon={Link01} subtitle="Connect your TikTok shop">
      {!shopStatus?.connected && <ReconnectCallout />}

      <div className="flex gap-8 items-start">
        {/* Promo card — photo + TikTok mark reused from the connections modal. */}
        <div
          className="relative overflow-hidden rounded-lg w-[314px] self-stretch shrink-0 pt-[24px] pb-[32px] px-[24px] h-[256px]"
          style={{ backgroundImage: "linear-gradient(161deg, rgb(27, 21, 37) 14.5%, rgb(42, 30, 50) 89.5%)" }}
        >
          <PromoVisual variant="card" />
        </div>

        <div className="flex-1 rounded-lg border border-secondary bg-primary p-[16px] gap-[32px] flex flex-col">
          <PermissionsList enabled highlightAds={highlightAds} />
        </div>
      </div>
    </PageLayout>
  );
}
